import type { PendingFindFilters } from "../../routes/find-route";

export type Collection = {
    id: string;
    title: string;
    tagline: string;

    lines: string[];
    filters: PendingFindFilters;
};

export const COLLECTIONS: Collection[] = [
    {
        id: "small",
        title: "Little & loyal",
        tagline: "Lap-sized pups",
        lines: ["Little &", "loyal"],
        filters: { size: ["toy", "small"] },
    },
    {
        id: "large",
        title: "Big & bold",
        tagline: "Big personalities",
        lines: ["Big &", "bold"],
        filters: { size: ["large", "giant"] },
    },
    {
        id: "fluffy",
        title: "Fluffy & fun",
        tagline: "Extra floof",
        lines: ["Fluffy &", "fun"],
        filters: { coatType: ["long", "curly", "double"] },
    },
    {
        id: "family",
        title: "Great with kids",
        tagline: "Family-ready",
        lines: ["Great with", "kids"],

        filters: {
            friendlinessChildren: [{ value: "5", operator: "gte" }],
        },
    },
    {
        id: "adventure",
        title: "Ready for adventure",
        tagline: "Trail & beach",
        lines: ["Ready for", "adventure"],

        filters: { energyLevel: [{ value: "5", operator: "gte" }] },
    },
    {
        id: "easygoing",
        title: "Easygoing",
        tagline: "Couch companions",
        lines: ["Easygoing"],

        filters: {
            breedSlugs: [
                "french-bulldog",
                "bulldog",
                "pug",
                "cavalier-king-charles-spaniel",
                "maltese",
                "great-dane",
                "basset-hound",
                "boston-terrier",
                "havanese",
                "bernese-mountain-dog",
            ],
        },
    },
    {
        id: "firsttimer",
        title: "First-time friendly",
        tagline: "Easy to train",
        lines: ["First-time", "friendly"],

        filters: { trainability: [{ value: "5", operator: "gte" }] },
    },
    {
        id: "lowshed",
        title: "Low-shedding",
        tagline: "Less vacuuming",
        lines: ["Low-shedding"],
        filters: { sheddingLevel: ["none", "minimal"] },
    },
];
